import Vue from 'vue';
import commonScripts from './common';
import stickyHeader from './partials/sticky_header';
import listingApp from './partials/listing';
import newsletter from './partials/newsletter';
import audioPlayer from './partials/audio_player';

commonScripts();
stickyHeader('.article__content');
listingApp();

const article_newsletter = document.querySelector('.article__newsletter');

if (article_newsletter) {
	new Vue({
		el: '.article__newsletter',
		delimiters: ['${', '}'],
		mixins: [newsletter]
	});
}

audioPlayer();


// WEBPACK FOOTER //
// ./assets/js/article.js